export default `<% var iconName = (data.icon && data.icon !== '') ? 'icon-' + data.icon : ''; %>

<li class="search-quick-links__item">
    <a class="btn btn--tiny" href="<%= translator.translateUrl(data.url) %>">
        <div id="sports-search-quick-links-<%= data.title.toLocaleLowerCase() %>" class="grid grid--vertical">
            <i class="search-quick-links__icon <%= iconName %>"></i>
            <p class="search-quick-links__title"><%= data.title %></p>
        </div>
    </a>
</li>`;